function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}
module.exports = _isObject;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_isObject.js
// module id = 150
// module chunks = 0